import { Form } from "ant-design-vue";
const { Item,...other } = Form;

const YwForm = {
	...other,
	name: "YwForm",
	Item: {
		...Item,
		name: "YwFormItem",
	},
};

YwForm.install = function (Vue) {
	Vue.component(YwForm.name, Form);
	Vue.component(YwForm.Item.name, Item);
	Vue.prototype.$form = Form
};

export default YwForm;
